import { createAPIModule } from '@/api/utils';

export default createAPIModule({
  endpoint: 'tipotrabajos',
  getAllParams: ({
    from, include, page, perPage, search, to,
  }) => ({
    'filter[nombre]': search,
    from,
    include,
    page,
    per_page: perPage,
    to,
  }),
});
